Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    miniCalendarMonthHeaderFontWeight: 600,
    miniCalendarMonthHeaderFontSize: 20,
    miniCalendarMonthWidth: 280,
    miniCalendarMonthMotionDuration: "200ms",
    miniCalendarMonthMotionFunction: "ease",
    miniCalendarDayOfWeekHeaderFontWeight: 600,
    miniCalendarDayOfWeekHeaderFontSize: 14,
    miniCalendarDayBackgroundColorSelected: tokens.themeForegroundAccentDefault,
    miniCalendarDayBackgroundColorHover: tokens.themeForegroundAccentHover,
    miniCalendarDayBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    miniCalendarDayBackgroundColorHighlighted: tokens.themeBackgroundAccentDefault,
    miniCalendarDayForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    miniCalendarDayForegroundColorSelected: tokens.themeForegroundInvertedDefault,
    miniCalendarDayForegroundColorHover: tokens.themeForegroundInvertedDefault,
    miniCalendarDayForegroundColorPressed: tokens.themeForegroundInvertedDefault,
    miniCalendarDayForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    miniCalendarDayBorderRadius: 4,
    miniCalendarDayMotionDuration: "100ms",
    miniCalendarDayMotionFunction: "ease",
    miniCalendarIndicatorColor: tokens.themeForegroundAccentDefault,
    miniCalendarIndicatorWidth: 24,
    miniCalendarIndicatorHeight: 2,
    miniCalendarIndicatorBorderRadius: 999,
    miniCalendarIndicatorSpacingVertical: 4,
    miniCalendarSpacingInset: 32,
    miniCalendarSpacingVertical: 8
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian-tokens/component/mini-calendar.js
// module id = 620
// module chunks = 0